export default __webpack_public_path__ + "static/media/icon-cluster-stops.234c8e62.svg";